// Escape a string for safe insertion into HTML. Used wherever user-supplied
// text (feature labels, display names) reaches an API that renders HTML — most
// notably Leaflet's bindTooltip / divIcon, which set innerHTML.
export function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ))
}
